import HelloWorld from "./pages/HelloWorld";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login";
import SignupPage from "./pages/signup";
import DeviceLogin from "./pages/deviceLogin";
import Dashboard from "./pages/dashboard";
import AppDownload from "./pages/appDownload";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HelloWorld />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          {/* Edge360 onboarding OAuth-style login gate */}
          <Route path="/device-login" element={<DeviceLogin />} />
          {/* Public, no-auth Android app download landing page */}
          <Route path="/download" element={<AppDownload />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/dashboard/devices/*"
            element={<Dashboard initialSelectedKey="devices" />}
          />
          <Route
            path="/dashboard/discover/*"
            element={<Dashboard initialSelectedKey="discover" />}
          />
          <Route
            path="/dashboard/home/*"
            element={<Dashboard initialSelectedKey="home" />}
          />
          <Route
            path="/dashboard/configurations/*"
            element={<Dashboard initialSelectedKey="configurations" />}
          />
          <Route
            path="/dashboard/releases/*"
            element={<Dashboard initialSelectedKey="releases" />}
          />
          <Route
            path="/dashboard/mobile-app/*"
            element={<Dashboard initialSelectedKey="mobile-app" />}
          />
          <Route
            path="/dashboard/device-details/:deviceId"
            element={<Dashboard initialSelectedKey="device-details" />}
          />

          <Route
            path="/dashboard/config-details/:configId"
            element={<Dashboard initialSelectedKey="config-details" />}
          />
          <Route
            path="/dashboard/pictures/:id?"
            element={<Dashboard initialSelectedKey="pictures" />}
          />
          <Route
            path="/dashboard/logs/:id?"
            element={<Dashboard initialSelectedKey="logs" />}
          />
          <Route
            path="/dashboard/users/*"
            element={<Dashboard initialSelectedKey="users" />}
          />
          <Route
            path="/dashboard/footfall"
            element={<Dashboard initialSelectedKey="footfall" />}
          />
          <Route
            path="/dashboard/footfall/:deviceId"
            element={<Dashboard initialSelectedKey="footfall" />}
          />
          <Route
            path="/dashboard/door-analytics"
            element={<Dashboard initialSelectedKey="door-analytics" />}
          />
          <Route
            path="/dashboard/frame-quality"
            element={<Dashboard initialSelectedKey="frame-quality" />}
          />
          <Route
            path="/dashboard/compliance-selections"
            element={<Dashboard initialSelectedKey="compliance-selections" />}
          />
          <Route
            path="/dashboard/selection-monitor"
            element={<Dashboard initialSelectedKey="selection-monitor" />}
          />
          <Route
            path="/dashboard/detection-health"
            element={<Dashboard initialSelectedKey="detection-health" />}
          />
          <Route
            path="/dashboard/threshold-bench"
            element={<Dashboard initialSelectedKey="threshold-bench" />}
          />
          <Route
            path="/dashboard/model-bench"
            element={<Dashboard initialSelectedKey="model-bench" />}
          />
          <Route
            path="/dashboard/sku-lab"
            element={<Dashboard initialSelectedKey="sku-lab" />}
          />
          <Route
            path="/dashboard/settings"
            element={<Dashboard initialSelectedKey="settings" />}
          />
          <Route
            path="/dashboard/reports"
            element={<Dashboard initialSelectedKey="reports" />}
          />
          <Route
            path="/dashboard/health"
            element={<Dashboard initialSelectedKey="health" />}
          />
          <Route
            path="/dashboard/health/:deviceId"
            element={<Dashboard initialSelectedKey="device-health" />}
          />
          <Route
            path="/dashboard/tickets"
            element={<Dashboard initialSelectedKey="tickets" />}
          />
          <Route
            path="/dashboard/tickets/:id"
            element={<Dashboard initialSelectedKey="ticket-detail" />}
          />
          <Route
            path="/dashboard/outlets/*"
            element={<Dashboard initialSelectedKey="outlets" />}
          />
          <Route
            path="/dashboard/shop-details/:id"
            element={<Dashboard initialSelectedKey="shop-details" />}
          />
          <Route
            path="/dashboard/visits/*"
            element={<Dashboard initialSelectedKey="visits" />}
          />
          <Route
            path="/dashboard/visit-detail/:id"
            element={<Dashboard initialSelectedKey="visit-detail" />}
          />
          <Route
            path="/dashboard/checklist-templates/*"
            element={<Dashboard initialSelectedKey="checklist-templates" />}
          />
          <Route
            path="/dashboard/team/*"
            element={<Dashboard initialSelectedKey="team" />}
          />
          {/* Unknown paths → auth gate (redirects to /dashboard or /login) */}
          <Route path="*" element={<HelloWorld />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
